
export type EnrollmentCreateResponseOneOfThreeResult = typeof EnrollmentCreateResponseOneOfThreeResult[keyof typeof EnrollmentCreateResponseOneOfThreeResult];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollmentCreateResponseOneOfThreeResult = {
  failed: 'failed',
} as const;
